import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppServiceService } from '../app-service.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductConfigAdminService {

  baseUrl?: string = '';
  manageUrl?: string = '';

  constructor(private http: HttpClient, private router: Router,
    private appService: AppServiceService,) {
    this.baseUrl = environment.BASE_URL;
    this.manageUrl = environment.DeviceManagement;
  }


  getEquipmentTableDetails(custId: Number) {
    return this.http.get(this.baseUrl + `EquipmentManagement/GetEquipmentMakeModels?custId=` + custId);
  }

  getEquipmentDropdownDetails(custId: Number) {
    return this.http.get(this.baseUrl + `EquipmentManagement/GetEquipmentTypes?custId=` + custId);
  }

  saveEquipmentData(data: any, custId: Number): Observable<any> {
    return this.http.post<any>(this.baseUrl + `EquipmentManagement/SaveEquipment?custId=` + custId, data);
  }

  editEquipmentDetail(data: any, custId) {
    return this.http.post(this.baseUrl + `EquipmentManagement/EditEquipementDetails?custId=` + custId, data);
  }

  deleteEquipmentVal(data: any, custId) {
    return this.http.post(this.baseUrl + `EquipmentManagement/DeleteEquipementDetails?custId=` + custId, data);

  }

  getUsersOfCustomer(custId: Number) {
    return this.http.get(this.baseUrl + 'UserAccess/GetUsersOfCustomer?custId=' + custId);
  }

  getCustomerUnits(custId, userId) {
    return this.http.get(this.baseUrl + `Units/GetUnits?custId=` + custId + '&userId=' + userId);
  }

  getRoles() {
    return this.http.get(this.baseUrl + `UserAccess/GetRoles`);
  }

  saveUserDetails(userdetails: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "MasterAdminConfiguration/SaveUsers", userdetails);
  }

  deleteTeamData(userId) {
    return this.http.delete<any>(this.baseUrl + `UserAccess/DeleteUsers?userId=` + userId);
  }

  editTeamDetail(data: any) {
    return this.http.post(this.baseUrl + "MasterAdminConfiguration/UpdateUsers", data);
  }

  getVendorTableDetails(custId: Number) {
    return this.http.get(this.baseUrl + `Vendor/GetVendors?custId=` + custId);
  }

  saveVendorData(data: any, custId: Number): Observable<any> {
    return this.http.post<any>(this.baseUrl + `Vendor/SaveVendorDetails?custId=` + custId, data);
  }

  editVendorData(data: any, custId) {
    return this.http.post(this.baseUrl + `Vendor/SaveVendorDetails?custId=` + custId, data);
  }

  deleteVendorData(vendorId) {
    return this.http.get<any>(this.baseUrl + `Vendor/DeleteVendor?vendorId=` + vendorId);
  }


  getRoleModuleMapping(custId: Number) {
    return this.http.get<any>(this.baseUrl + `RoleManagement/GetRoleModuleMapping?custId=` + custId);
  }

  updateRoleModuleMapping(custId: Number, data: any) {
    return this.http.post<any>(this.baseUrl + `RoleManagement/SaveRoleModulesAccess?custId=` + custId, data);
  }

  GetAllDevices() {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          //'skip': 'true',
          'Authorization': `Bearer ${this.appService.getUserToken()}`//`Bearer ${this.token}`
        }
      )
    };
    return this.http.get<any>(this.manageUrl + `PlatformDeviceManagement/GetAllDevices`, httpOptions);
  }
  GetDeviceDetailsByCustomerID(customerId: number) {
    return this.http.get<any>(this.manageUrl + `PlatformDeviceManagement/GetDeviceDetailsByCustomerID?customerId=` + customerId)
      .pipe(
        catchError(err => {
          return of(err);
        })
      );
  }
  AddNewDevice(data: any) {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          //'skip': 'true',
          'Authorization': `Bearer ${this.appService.getUserToken()}`//`Bearer ${this.token}`
        }
      )
    };
    return this.http.post(this.manageUrl + `PlatformDeviceManagement/AddNewDevice`, data);
  }

  GetDeviceDetailsByDeviceId(deviceId) {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.appService.getUserToken()}`
        }
      )
    };
    return this.http.get<any>(this.manageUrl + 'PlatformDeviceManagement/GetDeviceDetailsByDeviceId?deviceId=' + deviceId);
  }

  GenerateSASToken(data) {
    // const httpOptions = {
    //   headers: new HttpHeaders(
    //     {
    //       'Content-Type': 'application/json',
    //       //'skip': 'true',
    //       'Authorization': `Bearer ${this.appService.getUserToken()}`//`Bearer ${this.token}`
    //     }
    //   )
    // };
    return this.http.post<any>(this.manageUrl + `AzureIot/CreateSasToken`, data);
  }

  ReGenerateSASToken(data) {
    return this.http.post<any>(this.manageUrl + `AzureIot/RegenerateSasToken`, data);
  }

  GetAllAdaptorTypes() {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          //'skip': 'true',
          'Authorization': `Bearer ${this.appService.getUserToken()}`//`Bearer ${this.token}`
        }
      )
    };
    return this.http.get<any>(this.manageUrl + `PlatformDeviceManagement/GetAllAdaptorTypes`, httpOptions);
  }
  GetAllAuthenticationTypes() {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          //'skip': 'true',
          'Authorization': `Bearer ${this.appService.getUserToken()}`//`Bearer ${this.token}`
        }
      )
    };
    return this.http.get<any>(this.manageUrl + `PlatformDeviceManagement/GetAllAuthenticationTypes`, httpOptions);
  }
  UpdateDevice(data: any) {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          //'skip': 'true',
          'Authorization': `Bearer ${this.appService.getUserToken()}`//`Bearer ${this.token}`
        }
      )
    };
    return this.http.put(this.manageUrl + `PlatformDeviceManagement/UpdateDevice`, data);
  }
  getHMIInformation(custId: Number) {
    return this.http.get(this.baseUrl + `HMIIntegration/GetHMIInformation?custId=` + custId);
  }
  saveHMIInformation(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + `HMIIntegration/SaveHMIInformation`, data);
  }

  getGatewayOnboarding(custId: number) {
    return this.http.get(this.baseUrl + 'GatewayOnboarding/GetGatewayOnboarding?custId=' + custId);
  }
  saveGatewayOnboarding(data: any): Observable<any> {
    return this.http.post(this.baseUrl + 'GatewayOnboarding/SaveAndUpdateGatewayOnboarding', data);
  }
  LinkTaggedGatewayToEquipment(res: any): Observable<any> {
    return this.http.post(this.baseUrl + 'EquipmentDetails/LinkTaggedGatewayToEquipment', res);
  }
  DeLinkTaggedGatewayToEquipment(res: any): Observable<any> {
    return this.http.post(this.baseUrl + 'EquipmentDetails/DeLinkTaggedGatewayToEquipment', res);
  }

  CreateSASTokenForIOTDevices(res: any): Observable<any> {
    return this.http.post(this.baseUrl + 'EquipmentDetails/CreateSASTokenForIOTDevices', res);
  }

  GatewayCertificateDownload(res: any): Observable<any> {
    return this.http.get(this.baseUrl + 'EquipmentDetails/GatewayCertificateDownload?deviceId=' + res.deviceId);
  }

  
  HMICertificateDownload(res: any): Observable<any> {
    return this.http.get(this.baseUrl + 'EquipmentDetails/HMICertificateDownload?deviceId=' + res.deviceId);
  }

  LinkTaggedHMIToEquipment(res: any): Observable<any> {
    return this.http.post(this.baseUrl + 'EquipmentDetails/LinkTaggedHMIToEquipment', res);
  }
  DeLinkTaggedHMIToEquipment(res: any): Observable<any> {
    return this.http.post(this.baseUrl + 'EquipmentDetails/DeLinkTaggedHMIToEquipment', res);
  }

  CreateSASTokenForHMIIOTDevices(res: any): Observable<any> {
    return this.http.post(this.baseUrl + 'EquipmentDetails/CreateSASTokenForHMIIOTDevices', res);
  }

  getHMIData(custId: number) {
    return this.http.get(this.baseUrl + 'HMIIntegration/GetHMIInformation?custId=' + custId)
  }

  GetAPKFileData(): Observable<any>
  {
    return this.http.get<any>(this.baseUrl + 'AppVersion/GetAppVersionDetails');
  }

  GetAPKFileList(versionNumber:string): Observable<any>
  {
    return this.http.get(this.baseUrl + 'AppVersion/DownLoadAppApkFile?version=' + versionNumber,{responseType:'blob'});
  }

  SaveAPKFile(response:any): Observable<any> 
  {
    return this.http.post(this.baseUrl + 'AppVersion/ApkFileUpload', response);
  }
}
